import { Endpoints } from '../../constants/endpoints'
import { DataUserT } from '../../types/types'
import { getApiData } from '../_GLOBAL/getApiData'

export const getDataUser = (userName: string) => getApiData<DataUserT>(Endpoints.dataUser(userName))

export const getDataUserActive = () => getApiData<DataUserT[]>(Endpoints.dataUserActive())
